export const groupNames = {
  DEPARTMENTS: "Departments",
  EMPLOYEES: "Employees",
  GENERAL_PROJECT_SETTINGS: "General Project Settings",
  RIDDER_SYNC_LOGIN: "RidderSync login",
  SINGLE_PROJECT_GANTT_CONFIG: "Layout Single Project View",
  MULTI_PROJECT_GANTT_CONFIG: "Layout Multi Project View",
  DEPARTMENT_GANTT_CONFIG: "Layout Department View",
  ACCESS_RIGHTS: "User access rights",
  SCHEDULING: "Schedule synchronisation",
  USERS: "Users",
  HANGFIREDASHBOARD: "Hangfire Dashboard",
  INFOPAGE: "InfoPage",
};
